import React from 'react';
import PropTypes from 'prop-types';
import { SdfPagination } from '@waypoint/react-components';

const Pagination = ({
  totalProducts = 0,
  itemsPerPage = 10,
  callback = () => {},
  activePage = 1
}) => {
  const totalPages = Math.ceil(totalProducts / itemsPerPage) || 0;

  const onPageChange = ({ detail }) => {
    const startIndex = (detail - 1) * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, totalProducts);

    if (callback) {
      callback(detail, startIndex, endIndex);
    }
  };

  return (
    <div className='flex justify-center mt-3'>
      <SdfPagination
        currentPage={activePage}
        totalPages={totalPages}
        onSdfPageChange={onPageChange}
      />
    </div>
  );
};

Pagination.propTypes = {
  totalProducts: PropTypes.number.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  callback: PropTypes.func,
  activePage: PropTypes.number
};

export default Pagination;
